import { render, staticRenderFns } from "./TechShareDetail.vue?vue&type=template&id=34f4c571&scoped=true&"
import script from "./TechShareDetail.vue?vue&type=script&lang=js&"
export * from "./TechShareDetail.vue?vue&type=script&lang=js&"
import style0 from "./TechShareDetail.vue?vue&type=style&index=0&id=34f4c571&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f4c571",
  null
  
)

export default component.exports